<template>
  <div>
    <canvas :id="id" :height="height" class="ct-chart" v-scrollable="scrollable"></canvas>
  </div>
</template>

<script>
import BaseChart from './BaseChart.vue'

export default {
  name: 'line-chart',
  mixins: [BaseChart],
  data() {
    return {
      type: 'line',
    }
  },
  watch: {
    data(newVal, oldVal) {
      setTimeout(() => {
        this.updateData(newVal)
      }, 1000)
      this.$emit('wrapper-init', this.id)
    },
  },
}
</script>
